var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"jielong-demo"},[_c('div',{staticClass:"demo-header"},[_vm._v("接龙介绍编辑器")]),_c('jielong-intro',{model:{value:(_vm.cards),callback:function ($$v) {_vm.cards=$$v},expression:"cards"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }